
import Fetch from '../../common/Fetch';
import API_URL from "../../common/url";

export const getEmployeeCode = async () => {
    let employeeCode = sessionStorage.curEmployeeCode;
    const res = await Fetch.post(API_URL.user.getUserInfo, { employeeCode })
    return res
}


// WEBPACK FOOTER //
// ./src/components/common/getEmployeeCode.js